
  import { Vue, Component, Prop } from "vue-property-decorator";

  import GET_POSTINGS_EMPLOYMENT_TYPE from "@/apollo/autocomplete-queries/GetPostingsEmploymentType.gql";

  import DropdownFilter from "@/components/filters/DropdownFilter.vue";

  import DropdownOption from "@/entities/DropdownOption";
  import { Posting, Query_RootContractorArgs } from "@/generated/graphql";

  @Component({
    components: {
      DropdownFilter,
    },
    apollo: {
      postings: {
        query: GET_POSTINGS_EMPLOYMENT_TYPE,
        variables() {
          return this.filterConditions;
        },
        update(data) {
          return data.postings;
        },
      },
    },
  })
  export default class EmploymentMultiselect extends Vue {
    @Prop({ type: Array, required: true }) value!: DropdownOption[];
    @Prop({ type: Boolean, default: true }) withBorder!: boolean;
    @Prop({ type: Boolean, default: true }) multiple!: boolean;
    @Prop({ type: Boolean, default: false }) invalid!: boolean;
    @Prop({ type: Object, default: () => ({}) }) condition!: Object;

    postings: Posting[] = [];
    searchString = "";

    get employmentTypes(): String[] {
      return this.value.map((item) => item.name);
    }

    get employmentOptions(): DropdownOption[] {
      if (this.postings.length === 0) {
        return [];
      }

      return this.postings.map(
        ({ employment_type: employmentType, id }): DropdownOption => ({
          name: employmentType!,
          id,
        })
      );
    }

    get filterConditions(): Query_RootContractorArgs {
      const limit = 5;
      const conditions: any[] = [];

      if (this.searchString) {
        conditions.push({
          employment_type: {
            _ilike: `%${this.searchString}%`,
          },
        });
      }

      if (this.multiple && this.employmentTypes.length) {
        conditions.push({
          employment_type : { _nin: this.employmentTypes },
        });
      }

      if (conditions.length === 0) {
        return {
          where: this.condition,
          limit,
        };
      }

      return {
        where: { _and: [...conditions, this.condition] },
        limit,
      };
    }

    handleInput(val: DropdownOption[]) {
      this.$emit("input", val);
    }
  }
